import React from 'react';
import Header from 'components/Header';
import bgBottom from 'images/404bottomLeftIcon.svg';
import bgTop from 'images/TopRightIcon.svg';
import computerIcon from 'images/SomethingWentWrongIcon.svg';
import { breakpoints } from 'theme';
import NavigationColor from 'utils/constants/NavigationColor';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { rem } from 'polished';

const Container = styled.main`
  min-height: 100vh;

  background-image: url(${bgTop}), url(${bgBottom});
  background-repeat: no-repeat;
  background-position: right 180px, left 100%;

  @media (max-width: ${breakpoints.tablet}) {
    background-position: right 80px, left -28% bottom -5%;
    background-size: 45%;
  }
`;

const Content = styled.section`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: 170px;
  gap: 48px;

  @media (max-width: ${breakpoints.tablet}) {
    gap: 32px;

    padding-left: 24px;
    padding-right: 24px;
  }

  img {
    @media (max-width: ${breakpoints.tablet}) {
      width: 180px;
      height: auto;
    }
  }
`;

const Title = styled.h5`
  color: ${({ theme }) => theme.brandPalette.dark};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-size: ${rem(32)};
  line-height: ${rem(46)};

  @media (max-width: ${breakpoints.tablet}) {
    font-size: ${rem(24)};
    line-height: ${rem(27)};
  }
`;

const Body = styled.p`
  color: ${({ theme }) => theme.neutralPalette.neutral8};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: ${rem(20)};
  line-height: ${rem(32)};

  @media (max-width: ${breakpoints.tablet}) {
    line-height: ${rem(24)};
    font-size: ${rem(16)};
    margin-top: 16px;
  }
`;

const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Header variant={NavigationColor.DARK} />
      <Content>
        <img src={computerIcon} alt="" aria-hidden="true" />
        <span>
          <Title>{t('maintenance_status.title')}</Title>
          <Body>{t('maintenance_status.body')}</Body>
        </span>
      </Content>
    </Container>
  );
};

export default Maintenance;
